// 移动端断点：宽度 <= 768px 视为手机/窄屏
const MOBILE_MAX_WIDTH = 768;

// 报表表格移动端适配：窄屏下取消列冻结，避免冻结列占满屏幕导致无法横向滑动
export default {
  data() {
    return {
      // 当前是否为移动端窄屏
      isMobileScreen: false,
    };
  },
  computed: {
    // 是否启用 el-table-column 的 fixed 属性（PC 启用，移动端关闭）
    enableColumnFixed() {
      return !this.isMobileScreen;
    },
  },
  mounted() {
    // 初始化窄屏状态（首次进入页面时判断）
    this.updateMobileScreen();
    // 监听屏幕宽度变化（如旋转手机、调整窗口大小）
    this._mobileMediaQuery = window.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH}px)`);
    const handler = this.updateMobileScreen;
    // 兼容新旧 API：addEventListener / addListener
    if (this._mobileMediaQuery.addEventListener) {
      this._mobileMediaQuery.addEventListener('change', handler);
    } else {
      this._mobileMediaQuery.addListener(handler);
    }
  },
  beforeDestroy() {
    // 组件销毁前移除监听，避免内存泄漏
    if (!this._mobileMediaQuery) {
      return;
    }
    const handler = this.updateMobileScreen;
    // 兼容新旧 API：removeEventListener / removeListener
    if (this._mobileMediaQuery.removeEventListener) {
      this._mobileMediaQuery.removeEventListener('change', handler);
    } else {
      this._mobileMediaQuery.removeListener(handler);
    }
  },
  methods: {
    // 根据窗口宽度更新 isMobileScreen，供表格列冻结开关使用
    updateMobileScreen() {
      this.isMobileScreen = window.innerWidth <= MOBILE_MAX_WIDTH;
    },
  },
};
